export const posBar = {
	title: "Dispositivos por Bar",
	columns: {
		bar: "Bar",
		quantity: "Quantidade",
	},
};
